import { render, staticRenderFns } from "./TheLayoutBase.vue?vue&type=template&id=478ae06c&scoped=true"
import script from "./TheLayoutBase.vue?vue&type=script&lang=js"
export * from "./TheLayoutBase.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutBase.vue?vue&type=style&index=0&id=478ae06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ae06c",
  null
  
)

export default component.exports